module.exports = __webpack_public_path__ + "img/duye.0533b44b.png";